import styled from 'styled-components';

export const SectionTitleStyles = styled.h2`
  font-size: 3.2rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  color: #10231d;
  letter-spacing: -0.03em;
  @media only screen and (max-width: 768px) {
    font-size: 2.6rem;
  }
`;
export const TitleStyles = styled.h2`
  font-size: 2rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  @media only screen and (max-width: 768px) {
    font-size: 1.8rem;
  }
`;
